export const featureConfig = {
  ECO_SERVER: {
    trends: {
      sections: {
        summary: false,
        diagnostics: true,
        dimensions: true,
      },
      base: {
        'live-mode': false,
        'quick-compare-drilldown': false,
        compare: false,
        filter_popup: false,
        options_popover: false,
      },
    },
    common: {
      kpi: false,
    },
  },
  APP: {},
  EI: {},
  AI: {
    trends: {
      sections: {
        summary: false,
      },
    },
  },
  ODP: {
    trends: {
      sections: {
        summary: false,
        diagnostics: true,
        dimensions: true,
      },
      toggles: {
        'manual-alerts': false,
        'ai-alerts': false,
        annotations: false,
        dod: true,
      },
      actions: {
        share: false,
        save: false,
        export: true,
        'make-default': false,
      },
      base: {
        'live-mode': false,
        filter_popup: false,
        compare: false,
      },
    },
    common: {
      kpi: false,
      'header-context-id': true,
    },
  },
};
